module.exports = __webpack_public_path__ + "img/YogaView.80978362.png";